// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"194":"user-panel","289":"administration","996":"info"}[chunkId] || chunkId) + "." + {"194":"456fbd9d","289":"e1164e72","723":"715cf49a","790":"4126e0e7","996":"f26771eb"}[chunkId] + ".chunk.js";
};